<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
				<div class="title">近距离与专家交流</div>
				<div class="min-title">留下您的联系方式，即可预约专家时间，与专家近距离的沟通，解答您的疑惑。</div>
			</div>
            <div class="category">
				<div class="swiper-container" id="swiper-category">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in category_list" @click="chooseCategory(item,index)">
							<div class="item" :style="{backgroundImage:'url('+util.autoImage((category.id == item.id ? item.bg : item.bg2))+')'}" :class="[category.id == item.id ? 'active' : '']" >
								<div class="cen">
									<div class="middle">
										<div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
										<div class="icon icon-a"><img :src="util.autoImage(item.icon2)" alt=""></div>
										<div class="tit">{{item.title}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="category-box">
				<div class="box" v-for="(item,index) in category_list" @click="chooseCategory(item,index)" :key="index" v-if="index < 2" :class="[item.id == category.id ? 'active' : '']">
					<div class="tit">{{item.title}}</div>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in speaker_list" id="swiper1">
					<div class=" avatar">
						<div class="box">
							<div class="img" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
						</div>
					</div>
					<div class="info-box">
						<div class="info">
							<div class="user">
								<div class="username">{{item.username}}</div>
								<div class="job" v-html="item.job"></div>
							</div>
							<div class="description">{{item.desc}}</div>
						</div>
						<div class="chat">
							<div class="tt"></div>
							<div class="button" @click="showSpeaker(item)"><div class="left icon"></div><div class="left tit">预约专家交流</div></div>
						</div>
					</div>
				</div>
			</div>
            <div class="tips"><i>* </i>以上专家列表不分先后</div>
        </div>
		<speaker-message v-if="show_speaker.id" :speaker="show_speaker" @hideSpeaker="show_speaker = {}"></speaker-message>
    </main>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
import SpeakerMessage from "@/components/pc/SpeakerMessage";
export default {
	name: 'honored',
	data() {
		return {
			query:"",
			category_list:[],
			category:{},
			speaker_list:[],
			data_loading:true,

			show_speaker:{}
		}
	},
	components:{
		SpeakerMessage,
		Crumbs,Loading,swiper,swiperSlide
	},
	computed:{
		crumbs() {
			return {title:"专家面对面",min_title:"TALK TO EXPERT"}
		},
	},
	methods: {
		showSpeaker(item){
			gio('track', 'DTF2021_talkclick',{
				DTF2021_teachername:item.username,
			});

			this.show_speaker = item;
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-category',{
				slidesPerView:this.category_list.length > 5 ? 4.5 : 5,
				spaceBetween: 15,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		chooseCategory(item,index){
			this.category = item;
			this.getSpeakerList();
		},
		getSpeakerList(){
			this.http.request({
				api:"speaker/getSpeakerList",
				data:{
					speaker_category_id:this.category.id
				},
				success:(res)=>{
					this.speaker_list = res.list;
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
		getCategoryList(){
			this.http.request({
				api:"speaker/getCategoryList",
				success:(res)=>{
					this.category_list = res.category;
					this.category = res.category[0];
					this.getSpeakerList();
					this.$nextTick(()=>{
						this.swiperInit();
					})
				}
			})
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.getCategoryList();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{margin: 40px auto 0;background: url("~@/assets/image/2021/17.png") no-repeat bottom center;background-size:100% auto;
	.title-box{width: 1200px;margin: 0 auto; padding-left: 30px;background: url("~@/assets/image/2021/10.png") no-repeat left center;background-size: 100px;text-align: left;
		.title{font-size: 54px;line-height: 70px;color:#376f84;}
		.min-title{font-size:18px;color:#444;margin-top: 10px;}
	}
	.category{width: 1220px;margin: 40px auto 0;display: none;
		.swiper-container{padding:10px;
			.item{height:140px;border-radius: 5px; box-shadow: 0 0 10px 2px rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;
				.cen{display: inline-block;
					.middle{text-align: center;transition: all .3s ease;height:140px;
						.icon{width:50px;height:70px;display: block;
							img{width: 100%;height:100%;object-fit: contain;}
						}
						.icon-a{display: none;}
						.tit{color:#333;font-size: 16px;line-height: 36px;}
					}
				}
			}
			.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: cover;
				.cen{
					.middle{
						.icon{display: none;}
						.icon-a{display: block;}
						.tit{color:#fff;}
					}
				}
			}
			.item:nth-last-child(1){margin-right: 0;}
		}
	}
	.category-box{width: 1200px;margin: 40px auto 0;display: flex;
		.box{flex: 1;height:50px;background: url("~@/assets/image/b3.png") no-repeat center center;background-size: 100% 100%;text-align: center;line-height: 50px;color:#333;cursor: pointer;font-weight: bold;}
		.box.active{background: url("~@/assets/image/b1.png") no-repeat center center;background-size: 100% 100%;color:#fff;}
		.box:nth-child(2){margin-right: 0;background-image: url("~@/assets/image/b2.png");background-size: 100% 100%;color:#333;}
		.box:nth-child(2).active{background-image: url("~@/assets/image/b4.png");background-size: 100% 100%;color:#fff;}
	}
	.list{width: 1200px;margin: 40px auto 0;
		.item{padding: 30px;margin-bottom: 20px;box-shadow:0 0 10px 2px rgba(0,0,0,.1);background:#fff url("~@/assets/image/2021/21.png") no-repeat right center;background-size: 260px 100%;display: flex;
			.avatar{width: 148px;height:148px;position: relative;
				.box{position: absolute;top:0;left:0;width: 100%;height:100%;z-index: 2;overflow: hidden ;background: url("~@/assets/image/2021/36.png") no-repeat center center;background-size: 100% 100%;border-top-right-radius: 66px;border-bottom-left-radius:66px;
					.img{width: 80%;height:90%;position: absolute;top:10%;left:10%; background-repeat: no-repeat;background-position:center center;background-size: cover;}
				}
			}
			.avatar::before{content: "";display: block;position: absolute;top:-10px;right:-10px;width: 80px;height:80px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: 100% 100%;}
			.avatar::after{content: "";display: block;position: absolute;bottom:-10px;left:-10px;width: 80px;height:80px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: 100% 100%;}
			.info-box{display: flex;flex-wrap: wrap;flex: 1;
				.info{flex: 1;margin-left: 32px;margin-right: 22px;
					.user{padding-bottom: 10px;border-bottom:1px solid #EEEEEE;
						.username{font-size: 14px;line-height: 21px;font-weight: bold;padding-left: 16px;background: url("~@/assets/image/2021/24.png") no-repeat left center;background-size: 7px;}
						.job{font-size: 14px;line-height: 19px;color:#808080;margin-top: 10px;}
					}
					.description{padding-top: 10px;font-size: 14px;line-height: 21px;color:#808080;}
				}
				.chat{width: 216px;position: relative;
					.tt{width: 133px;height:36px;background: url("~@/assets/image/2021/22.png") no-repeat center center;background-size: contain;position: absolute;top:40%;left:50%;transform: translate(-50%,-50%);display: none;}
					.button{width: 156px;height:40px;display: flex;cursor: pointer;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);
						.icon{width: 40px;background: #138EEA url('~@/assets/image/2021/23.png') no-repeat center center;background-size: 18px;}
						.tit{flex: 1;background: #376f84;text-align: center;line-height: 40px;color:#fff;transition: all .3s ease;}
					}
					.button:hover{
						.tit{background:#138EEA;transition: all .3s ease;}
					}
				}
			}
		}
	}
	.tips { font-size:14px; padding-bottom: 50px;text-align: left;color:#999;width: 1200px;margin: 0 auto;
		i{color:red;}
	}
}
</style>

